<template>
  <div class="mermber">
    <div :class="['head-bg', { 'decennial-bg': Info.isInMemberTenthAct }]"></div>
    <Bar title="小盒会员中心" />
    <div class="main">
      <img
        class="title_img"
        :src="Info.banner.imgUrl"
        @click="jumpBanner(Info.banner.jumpUrl)"
      />
      <div class="content">
        <span class="vip-text">会员</span>
        <div class="menu">
          <div
            v-for="(item, idx) of realPackageList"
            :key="idx"
            class="item-no"
            :class="{ item: idx == selectMenu }"
            @click="selectPackage(idx,item)"
          >
            <div v-if="item.productDesc[4]" class="tip-above-bg">{{ item.productDesc[4] }}</div>
            <div class="text-doc">{{ item.title }}</div>
            <div v-if="idx == selectMenu && item.productDesc[0]" :class="['tip-bg', { 'decennial-sign-bg': Info.isInMemberTenthAct && Info.indexSelected === idx }]">{{ item.productDesc[0] }}</div>
            <div v-else :class="['item-nom', { 'decennial-sign-bg': Info.isInMemberTenthAct && Info.indexSelected === idx }]">{{ item.productDesc[0] }}</div>
            <div>
              <span class="price-icon">￥</span><span class="price">{{ getPrice(item.discountPrice) }}</span>
              <!-- <br>
              <span v-if="item.awardId > 0" class="price-discount">券后</span> -->
            </div>
            <div v-if="item.awardId > 0 || +item.showOriginPrice === 1" class="second">
              ￥{{ getPrice(item.originPrice) }}
            </div>
          </div>
        </div>
        <div v-if="realPackageList[selectMenu].productDesc[1].length > 0" 
          :class="realPackageList[selectMenu].isPureSign == 1?'tip-doc' : 'tipNoAfter'" @click="handleClickTip()">
          {{
            realPackageList[selectMenu].productDesc[1]
          }}
        </div>
        <img
          v-if="Info.isInMemberAct == 1"
          class="activity_img"
          src="../../assets/images/member_new/bg_member_activity.png"
        />
        <div class="actBanner-swiper" v-if="Array.isArray(Info.actBanner) && Info.actBanner.length">
          <van-swipe
            ref="swiper"
            class="banner-list"
            :show-indicators="true"
            :touchable="true"
            :autoplay="0"
          >
            <van-swipe-item
              v-for="(item, index) in Info.actBanner"
              :key="index"
            >
              <img
                :src="item.imgUrl"
                alt=""
                class="actBanner"
                @click="jump(item)"
              />
            </van-swipe-item>
          </van-swipe>
        </div>
        <!-- <div v-if="Info.isInReturnMoneyAct2023" class="activity-banner">
          <img
            src="https://susuanqiniu.knowbox.cn/fe/xhxx/member-new/return-money-act-20230922.png"
            alt="2023年打卡返年费"
            class="return-money-pic"
          >
        </div> -->
        <div class="activity-banner">
          <div class="img-wrap" v-for="(item, index) in xhhyImgUrlList" :key="index">
            <img class="return-money-pic" alt="20240604img" :src="item" />
          </div>
        </div>
        <!-- <div
          v-else-if="Info.act20230901"
          class="activity-banner"
        >
          <img
            src="https://susuanqiniu.knowbox.cn/fe/xhxx/member-new/act20230901-new.png"
            alt="2023年秋季开学季买会员送学贝"
            class="pic"
          >
        </div> -->
        <!-- <span class="vip-text">会员权益</span>
        <div class="rights">
          <div class="vip-rights">
            <div class="title-block">
              <img src="../../assets/images/member_new/king-icon.png" alt="" class="icon">
              <span class="text">会员权益</span>
            </div>
            <div class="rights-block">
              <div class="rights-cell" v-for="(item, index) in benefits" :key="index">
                <div class="benefit-type">
                  <img src="../../assets/images/member_new/vip-icon.png" alt="" class="vip-icon">
                  <span class="title">{{ item.title }}</span>
                </div>
                <div class="list">
                  <div v-for="(cell, i) in item.list" :key="i" class="list-cell" @click="showEquities(cell.hrefIndex)" :style="{'visibility': ((index === 2 && i > 1) || (index === 3 && i > 0))?'hidden':'visible'}">
                    <img :src="cell.icon" alt="" class="list-icon">
                    <span class="list-text">{{ cell.text }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="not-vip-rights">
            <div class="title-block">非会员</div>
            <div class="cnt">
              <div class="cnt-cell">
                <span>音视频绘本</span>
                <span>权益受限</span>
              </div>
              <div class="cnt-cell">
                <span>专项练习</span>
                <span>权益受限</span>
              </div>
              <div class="cnt-cell">
                <span>普通用户</span>
                <span>无双倍学贝奖励</span>
              </div>
              <div class="cnt-cell">
                <span>同步练</span>
                <span>权益受限</span>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="benifit-list">
          <div class="benifit-list-child" @click="showEquities(0)">
            <img class="img" src="../../assets/images/member_new/ic_book.png"/>
            <div class="text">精品绘本</div>
          </div>
           <div class="benifit-list-child"  @click="showEquities(1)">
            <img class="img" src="../../assets/images/member_new/ic_video.png"/>
            <div class="text">趣味视频</div>
          </div>
           <div class="benifit-list-child"  @click="showEquities(2)">
            <img class="img" src="../../assets/images/member_new/ic_audio.png"/>
            <div class="text">海量音频</div>
          </div>
          <div class="benifit-list-child"  @click="showEquities(3)">
            <img class="img" src="../../assets/images/member_new/ic_exercise.png"/>
            <div class="text">同步练</div>
          </div>
          <div class="benifit-list-child"  @click="showEquities(4)">
            <img class="img" src="../../assets/images/member_new/ic_pk.png"/>
            <div class="text">速算闯关</div>
          </div>
           <div class="benifit-list-child"  @click="showEquities(5)">
            <img class="img" src="../../assets/images/member_new/ic_college.png"/>
            <div class="text">魔法学院</div>
          </div>
           <div class="benifit-list-child"  @click="showEquities(6)">
            <img class="img" src="../../assets/images/member_new/ic_idiom.png"/>
            <div class="text">成语学堂</div>
          </div>
          <div class="benifit-list-child" v-if="Number(nowVersion) < 5124" @click="showEquities(7)">
            <img class="img" src="../../assets/images/member_new/ic_study.png"/>
            <div class="text">学霸计划</div>
          </div>
          <div class="benifit-list-child"  @click="showEquities(Number(nowVersion) < 5124?8:7)">
            <img class="img" src="../../assets/images/member_new/ic_gold.png"/>
            <div class="text">双倍学贝奖励</div>
          </div>
           <div class="benifit-list-child"  @click="showEquities(Number(nowVersion) < 5124?9:8)">
            <img class="img" src="../../assets/images/member_new/ic_member.png"/>
            <div class="text">会员身份标识</div>
          </div>
        </div> -->
    
        <div v-show="sourceC == 'ios'" class="renew-doc">续费说明</div>
        <div v-show="sourceC == 'ios'" class="rener-doc-p">
          <p>
            1.付款：“连续包月/季/年”会员为自动续费类商品，确认购买后，会从您的苹果iTunes账号中扣款
          </p>
          <p>
            2.续费：在您订阅周期到期前24小时内，苹果会自动从iTunes账户中扣款，扣款成功将自动延长会员有效期
          </p>
          <p>
            3.取消付费：如需取消续费，请在距离订阅期至少24小时之前，手动在Apple
            ID账户设置中关闭自动续费，关闭后将不再扣款
          </p>
        </div>
      </div>
      <div class="other">
        <div class="o-item" @click="goQuestion">
          <div class="o-text">常见问题</div>
          <div class="line"></div>
        </div>
        <div class="o-item"  v-if="sourceC == 'ios' && versionStr >= '5002' "  @click="restoreProduct">
          <div class="o-text">恢复购买</div>
          <div class="line"></div>
        </div>
        <div class="o-item" @click="goPrivacy">
          <div class="o-text">隐私政策</div>
          <div class="line"></div>
        </div>
        <div class="o-bottom">
          <div class="text-bottom">联系客服</div>
          <div class="b-tip">客服电话：<span>4000 100 180</span></div>
          <div class="b-tip">工作时间：周一至周日 08:00-22:00</div>
        </div>
      </div>
      <div class="footer-zhan"></div>
    </div>
    <Footer
      :Info="Info"
      :source="sourceC"
      :item="realPackageList[selectMenu]"
      title="开通年度会员"
      btnText="Info.memberProductList[selectMenu].title"
      ref="footer"
      @toggleMemberProductPopup="toggleMemberProductPopup"
    />
    <van-popup v-model="showPop" round>
      <div class="pop-content">
        <div class="pop-title">自动续费声明</div>
        <div class="pop-scroll">
          <p>
            1.付款：“连续包月/季/年”会员为自动续费类商品，确认购买后，会从您的苹果iTunes账号中扣款
          </p>
          <p>
            2.续费：在您订阅周期到期前24小时内，苹果会自动从iTunes账户中扣款，扣款成功将自动延长会员有效期
          </p>
          <p>
            3.取消付费：如需取消续费，请在距离订阅期至少24小时之前，手动在Apple
            ID账户设置中关闭自动续费，关闭后将不再扣款
          </p>
        </div>
        <div class="pop-footer">
          <div class="know" @click="showPop = false">知道了</div>
        </div>
      </div>
    </van-popup>
    <div class="suc-van-popup-container">
      <van-popup v-model="showSuc" :get-container="() => {return document.querySelector('suc-van-popup-container');}" round closeable :close-icon="imgX">
        <div class="pop-suc">
          <img :src="icon_member_bg" class="pop-img" />
          <div class="pop-begin" @click="beginStudy()">赠送给好友会员3天体验卡</div>
        </div>
      </van-popup>
    </div>
    <same-member-product-popup
      v-if="showSameProductPopup"
      @toggleMemberProductPopup="toggleMemberProductPopup"
    >
    </same-member-product-popup>
    <div class="share-wrap" v-if="showShare" @click="handleClose"
       style="width:100%;position:fixed;bottom:0;left:0">
      <invite-share :shareUrl="Info.shareUrl" :shareTitle="Info.shareTitle" :shareDesc="Info.shareDesc" @closeWrap="closeShare"
        actionCode="hzxx3117"
        ></invite-share>
    </div>
    <!-- 2023年秋季开学季活动-会员购买完成后出现弹框 -->
    <van-popup
      v-model="showAct20230901Dialog"
      class="act20230901-dialog"
    >
      <div class="title">
        赠送给您
      </div>
      <div class="bd">
        <img
          :src="popupImgUrl"
          alt="代金券"
          class="coin"
        >
        <p class="text">
          {{ popupText }}
        </p>
      </div>
      <div class="ft">
        <div
          class="button"
          @click="handleJumpToShop"
        >
          前往小盒商城领取奖品
        </div>
      </div>
      <div
        class="close"
        @click="handleCloseAct20230901Dialog"
      ></div>
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import { Swipe, SwipeItem } from "vant";
Vue.use(Swipe).use(SwipeItem)
import ajax from "@/api/memberAjax.js";
import utils from "@/assets/js/utils";
import { isEmptyStr } from "@/utils/utils";
import Bar from "./member_bar";
import Footer from "./member_footer_new";
import SameMemberProductPopup from "./same_member_product_popup";
import { restoreProduct } from "@/utils/hybird";
import inviteShare from "../parent_active/invite-parent/common/invite-share";//邀请
const token = utils.getQueryString("token");
const version = utils.getQueryString("version");
const source = utils.getQueryString("source");
const categoryId = utils.getQueryString("categoryId");
const pageChannelId = utils.getQueryString("pageChannelId");
const productId = utils.getQueryString("productId"); //商品Id
const strAwardId = utils.getQueryString("awardId");
// 

var vm = null;
window.failToast = function (res) {
  if (res == "cancel") {
    // vm.showFailToast = true;
    vm.$toast("支付失败");
  } else {
    if (vm.sourceC === 'ios') {
      if (vm.Info.act20230901) {
        utils.sendLog({
          token,
          version,
          source,
          extensionJson: {
            product: vm.selectMenu
          }
        }, 'hzxx4211');

        vm.showAct20230901Dialog = true;
      }
    }
  }
};

window.jsCallback = function (res) {
  if (res == "cancel") {
    vm.$toast("支付失败");
  } else {
    // for android only
    if (vm.Info.act20230901) {
      utils.sendLog({
        token,
        version,
        source,
        extensionJson: {
          product: vm.selectMenu
        }
      }, 'hzxx4211');

      vm.showAct20230901Dialog = true;
    }

    if (window.goAddress)
      window.location.href =
        "/#/address?version=" +
        version +
        "&token=" +
        token +
        "&source=" +
        source;
    else {
      vm.showSuc = true; 
      utils.sendLog({
                token: token,
                version: version,
                source: source,
                extensionJson: {
                    type: 1,
                }
            }, 'hzxx3113');
    }
  }
};

const imgUrlPrefix = "https://susuanqiniu.knowbox.cn/fe/xhxx/member-new/";
const xhhyImgUrlList = [`${imgUrlPrefix}xhhy-1.jpg?v=2`, `${imgUrlPrefix}xhhy-2.png?date=20250313`, `${imgUrlPrefix}xhhy-3.png?date=20250313`, `${imgUrlPrefix}xhhy-4.jpg?v=2`, `${imgUrlPrefix}xhhy-5.jpg?v=3`];

export default {
  components: {
    Bar,
    Footer,
    SameMemberProductPopup,
    inviteShare
  },
  data() {
    return {
      xhhyImgUrlList,
      nowVersion: version,
      icon_member_bg:require("../../assets/images/member_new/ic_member_month.png"),
      icon_month:require("../../assets/images/member_new/ic_member_month.png"),
      icon_season:require("../../assets/images/member_new/ic_member_season.png"),
      icon_year:require("../../assets/images/member_new/ic_member_year.png"),
      versionStr: '',
      imgX: require("../../assets/images/member_new/btn_X.png"),
      showTitleBg: false,
      showPop: false,
      showShare: false,
      showSuc: false,
      selectMenu: 0,
      showSameProductPopup: false, // 已购买套餐弹窗
      sourceC: "", //平台
      text: {},
      Info: {
        // memberProductList:[{}]
        banner:{

        },
        memberInfo: {
          isMember: 0, // 是否是会员 1是 0否
          username: "小白兔白又白🐰",
          memberDesc: "开通会员 全场免费学", // 会员信息描述
        },
        needUpgrade: 1, // 是否升级,1是 0否,如果是1时
        superMember: 12, // 超级会员时间,单位天
        syncTest: 124, // 同步练会员时间,单位天
        // freeDays: 123,// 升级时免费天数
        awardList: [
          //助学金记录列表
          {
            recordId: 1, // 助学金记录id
            awardId: 7, // 助学金类型id 7=助学金45 8=助学金10 9=助学金5
            endTime: 1629431353293, // 有效期截止时间戳
          },
           {
            recordId: 2, // 助学金记录id
            awardId: 7, // 助学金类型id 7=助学金45 8=助学金10 9=助学金5
            endTime: 1629431353293, // 有效期截止时间戳
          },
          {
            recordId: 3, // 助学金记录id
            awardId: 8, // 助学金类型id 7=助学金45 8=助学金10 9=助学金5
            endTime: 1629431353293, // 有效期截止时间戳
          },
          {
            recordId: 4, // 助学金记录id
            awardId: 8, // 助学金类型id 7=助学金45 8=助学金10 9=助学金5
            endTime: 1629431353293, // 有效期截止时间戳
          },
          {
            recordId: 5, // 助学金记录id
            awardId: 9, // 助学金类型id 7=助学金45 8=助学金10 9=助学金5
            endTime: 1629431353293, // 有效期截止时间戳
          },
           {
            recordId: 6, // 助学金记录id
            awardId: 9, // 助学金类型id 7=助学金45 8=助学金10 9=助学金5
            endTime: 1629431353293, // 有效期截止时间戳
          },
        ],
        memberProductList: [
          // needUpgrade=1时此字段只有升级对应产品
          {
            productId: 993, // 产品id
            title: "连续包月", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 1, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 23, // 会员连续包月
            awardId: -9, //助学金id
            productDesc:["11","11","11"],
          },
          {
            productId: 994, // 产品id
            title: "连续包月优惠", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 1, // 是否有价格比对
            productType: 24, // 会员连续包月优惠
            awardId: -9, //助学金id
            productDesc:["11","11","11"],
          },
          {
            productId: 995, // 产品id
            title: "连续包季", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 25, // 会员连续包季
            awardId: -8, //助学金id
            productDesc:["11","11","11"],

          },
          {
            productId: 996, // 产品id
            title: "连续包年", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 26, // 会员连续包年
            awardId: -7, //助学金id
            productDesc:["11","11","11"],
          },
          {
            productId: 997, // 产品id
            title: "1个月", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 27, // 会员1个月
            awardId: 0, //助学金id
            productDesc:["11","11","11"],
          },
          {
            productId: 998, // 产品id
            title: "1个季度", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 28, // 会员1个季度
            awardId: 0, //助学金id
            productDesc:["11","11","11"],
          },
          {
            productId: 0, // 产品id
            title: "1年", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 29, // 会员1年
            awardId: 0, //助学金id
            productDesc:["11","11","11"],
          },
          {
            productId: 993, // 产品id
            title: "连续包月", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 1, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 23, // 会员连续包月
            awardId: 9, //助学金id
            productDesc:["11","11","11"],
          },
          {
            productId: 9955, // 产品id
            title: "连续包季", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 25, // 会员连续包季
            awardId: 8, //助学金id
            productDesc:["11","11","11"],
          },
          {
            productId: 996, // 产品id
            title: "连续包年", // 标题
            originPrice: 158, // 原价
            discountPrice: 158, // 优惠价
            isPromotion: 0, // 是否有首次开通标识,1是 0否
            isRecommend: 0, // 是否是推荐,1是 0否
            hasPriceCompare: 0, // 是否有价格比对
            productType: 26, // 会员连续包年
            awardId: 7, //助学金id
            productDesc:["11","11","11"],
          },
        ],

        act20230901: 0, // 活动是否开启 1是 0否
      },
      realPackageList: [
        // needUpgrade=1时此字段只有升级对应产品
        {
          productId: 993, // 产品id
          title: "连续包月", // 标题
          originPrice: 35, // 原价
          discountPrice: 1, // 优惠价
          isPromotion: 1, // 是否有首次开通标识,1是 0否
          isRecommend: 0, // 是否是推荐,1是 0否
          hasPriceCompare: 0, // 是否有价格比对
          productType: 23, // 会员连续包月
          awardId: -7, //助学金id
          productDesc:[1,2,3],

        },
        {
          productId: 994, // 产品id
          title: "连续包月优惠", // 标题
          originPrice: 35, // 原价
          discountPrice: 35, // 优惠价
          isPromotion: 0, // 是否有首次开通标识,1是 0否
          isRecommend: 0, // 是否是推荐,1是 0否
          hasPriceCompare: 1, // 是否有价格比对
          productType: 24, // 会员连续包月优惠
          awardId: -7, //助学金id
          productDesc:[1,2,3],

        },
        {
          productId: 995, // 产品id
          title: "连续包季", // 标题
          originPrice: 78, // 原价
          discountPrice: 78, // 优惠价
          isPromotion: 0, // 是否有首次开通标识,1是 0否
          isRecommend: 0, // 是否是推荐,1是 0否
          hasPriceCompare: 0, // 是否有价格比对
          productType: 25, // 会员连续包季
          awardId: -7, //助学金id
          productDesc:[1,2,3],
        },
      ],
      benefits: [{
        title: '全场音视频绘本无限畅享',
        list: [{
          icon: require('../../assets/images/member_new/ic_book.png'),
          text: '精品绘本',
          hrefIndex: 0,
        },{
          icon: require('../../assets/images/member_new/ic_video.png'),
          text: '趣味视频',
          hrefIndex: 1,
        },{
          icon: require('../../assets/images/member_new/ic_audio.png'),
          text: '海量音频',
          hrefIndex: 2,
        }]
      },{
        title: '多模块专项练习权益启用',
        list: [{
          icon: require('../../assets/images/member_new/ic_pk.png'),
          text: '速算闯关',
          hrefIndex: 4,
        },{
          icon: require('../../assets/images/member_new/ic_college.png'),
          text: '魔法学院',
          hrefIndex: 5,
        },{
          icon: require('../../assets/images/member_new/ic_idiom.png'),
          text: '成语学堂',
          hrefIndex: 6,
        }]
      },{
        title: '会员专享福利',
        list: [{
          icon: require('../../assets/images/member_new/ic_gold.png'),
          text: '双倍学贝',
          hrefIndex: 7,
        },{
          icon: require('../../assets/images/member_new/ic_member.png'),
          text: '会员标识',
          hrefIndex: 8,
        },{
          icon: '',
          text: '',
          hrefIndex: 0,
        }]
      },{
        title: '全年级练习打卡免费使用',
        list: [{
          icon: require('../../assets/images/member_new/ic_exercise.png'),
          text: '同步练',
          hrefIndex: 3,
        },{
          icon: '',
          text: '',
          hrefIndex: 0,
        },{
          icon: '',
          text: '',
          hrefIndex: 0,
        }]
      }],

      showAct20230901Dialog: false
    };
  },
  created() {
    this.getInfo();

    vm = this;
    this.versionStr = utils.getQueryString('version').split('.').join('');

  },
  mounted() {
    this.sourceC = source.match("iPhone") ? "ios" : "and";
  },
  methods: {
    closeShare() {
            this.showShare = false;
        },
    typePriceMap(productType) {
      let discountPrice;
      this.Info.memberProductList.some((item, index) => {
        if (item.productType === productType) {
          discountPrice =
            productType === 24 ||
            productType === 52 ||
            productType === 53 ||
            productType === 54 ||
            productType === 55 ||
            productType === 56
              ? item.originPrice
              : item.discountPrice;
          return true;
        }
      });
      return discountPrice;
    },
    formData() {
      this.Info.memberProductList.forEach((item, index) => {
        switch (item.productType) {
          case 57:
            //85折1个月
            this.text[item.productId] = `选择【连续包月】套餐，每月立省${
              item.originPrice -
              (this.typePriceMap(54) || this.typePriceMap(71))
            }元`;
            break;
          case 58:
            this.text[item.productId] = `选择【连续包季】套餐，每季立省${
              item.originPrice - this.typePriceMap(55)
            }元`;
            break;
          case 59:
            this.text[item.productId] = `选择【连续包年】套餐，每年立省${
              item.originPrice - this.typePriceMap(56)
            }元`;
            break;
          case 71:
            this.text[
              item.productId
            ] = `免费期结束后，每月自动续费${item.originPrice}元，可随时关闭`;
            break;
          case 54:
            this.text[
              item.productId
            ] = `次月起每月自动续费${item.originPrice}元，可随时关闭`;
            break;
          case 55:
            this.text[
              item.productId
            ] = `次季起每季自动续费${item.originPrice}元，可随时关闭`;
            break;
          case 56:
            this.text[
              item.productId
            ] = `次年起每年自动续费${item.originPrice}元，可随时关闭`;
            break;
          case 23:
            this.text[
              item.productId
            ] = `每月自动续费${item.discountPrice}元，可随时关闭`;
            break;
          case 24:
          case 52:
          case 53:
            if (item.productType == 24) {
              this.btnDiscountPrice = item.discountPrice;
            }
            this.text[
              item.productId
            ] = `次月起每月自动续费${item.originPrice}元，可随时关闭`;
            break;
          case 25:
            this.text[
              item.productId
            ] = `每季自动续费${item.discountPrice}元，可随时关闭`;
            break;
          case 26:
            // this.text[item.productId] = `每年自动续费${item.discountPrice}元，可随时关闭`;
            this.text[item.productId] =
              "次年起每年自动续费308.00元，可随时关闭";
            break;
          case 27:
            let typeMap =
              this.typePriceMap(71) ||
              this.typePriceMap(23) ||
              this.typePriceMap(24) ||
              this.typePriceMap(52) ||
              this.typePriceMap(53);
            this.text[item.productId] = `选择【连续包月】套餐，每月立省${
              item.discountPrice - typeMap
            }元`;
            break;
          case 28:
            this.text[item.productId] = `选择【连续包季】套餐，每季立省${
              item.discountPrice - this.typePriceMap(25)
            }元`;
            break;
          case 29:
            this.text[item.productId] = `选择【连续包年】套餐，每年立省${
              item.discountPrice - this.typePriceMap(26)
            }元`;
            break;
        }
      });
    },
    async getInfo() {
      const [resp] = await ajax.all([
        ajax.get("/pay/common/member-sale-page-new", {
          params: {
            token,
            version,
            source,
          },
        }),
      ]);
      if (resp.data.code == 99999) {
        console.log(resp.data);
        let data = resp.data.data;
        this.Info = data;
        if(Array.isArray(this.Info.actBanner) && this.Info.actBanner.length) {
          this.Info.actBanner.forEach(i => {
            utils.sendLog({
              token: token,
              version: version,
              source: source,
              extensionJson: {
                actBannerId: i.id,
              }
            }, 'hzxx3245');
          })
        }
        this.selectMenu = this.Info.indexSelected;
        this.currentProduct = this.Info.memberProductList[this.selectMenu];
        this.setMemberDialogBg();
        this.showIf = true;
        if (this.Info.needUpgrade) {
          gio("track", "vipUpdatePage_show", this.getGioParams());
          utils.sendLog(
            {
              token,
              version,
              source,
              extensionJson: this.getGioParams(),
            },
            "hzxx912"
          );
        } else {
          gio("track", "vipOpenPgae_show", this.getGioParams());
          utils.sendLog(
            {
              token,
              version,
              source,
              extensionJson: this.getGioParams(),
            },
            "hzxx910"
          );
        }

        this.formData();
        this.setDiscountPackageInfo(strAwardId);
      }
      
    },
    beginStudy(){
      this.showSuc = false;
      //调起分享
      this.showShare = true;
      // window.location.href = 'hybird://method/exit'
      utils.sendLog({
                token: token,
                version: version,
                source: source,
                extensionJson: {
                    type: 1,
                }
            }, 'hzxx3114')
    },
    handleClose(e) {
      if (e.target.classList.contains('share-wrap')) {
          this.showShare = false;
      }
    },
    jumpBanner(jumpUrl){
      if(jumpUrl.length == 0) return;
      let url = encodeURIComponent(jumpUrl);
      window.location.href = "hybird://method/openNewWindow?url=" + url;
    },
    setDiscountPackageInfo(awardId) {
        //radio=-1表示取消
      this.realPackageList = this.Info.memberProductList.filter(
        (n) => n.awardId <= 0
      );
      let locationIndex = 0;
      this.realPackageList.forEach((item,i) =>{
          //有可用优惠卷
          if(this.Info.awardList.find(n => n.awardId == -item.awardId) != null){
            let wardId = -item.awardId;
            let discountPackage = this.Info.memberProductList.filter((n) => n.awardId == wardId)[0];
            let replaceIndex = this.realPackageList.findIndex((n) => n.awardId == -wardId);
            if(wardId == awardId){
                locationIndex = replaceIndex;
            }
            this.realPackageList.splice(replaceIndex, 1, discountPackage);
          }
      })

      if (awardId != null && awardId > 0) {
        this.selectMenu = locationIndex;

      }
       this.$refs.footer.setButtonName(this.realPackageList[this.selectMenu]);
    },
    selectPackage(idx,currentItem){
      this.currentProduct = currentItem;
      this.selectMenu = idx;
      this.$refs.footer.setButtonName(currentItem);

      this.setMemberDialogBg();
    },
    setMemberDialogBg(){
      if(vm.realPackageList.length && vm.realPackageList.length - 1 >= this.selectMenu) {
        switch(vm.realPackageList[this.selectMenu].identityDesc){
          case "月度会员":
            vm.icon_member_bg = vm.icon_month;
            break;
          case "季度会员":
            vm.icon_member_bg = vm.icon_season;
            break;
          case "年度会员":
            vm.icon_member_bg = vm.icon_year;
          break;
        }
      }
    },
    getPrice(price) {
      if (!price) return false;
      let arr = price.toString().split(".");
      return arr[0];
    },
    handleClickTip(){
        if(this.realPackageList[this.selectMenu].isPureSign == 1){
          this.showPop = true;
        }
    },
    getGioParams() {
      return {
        categoryId,
        pageChannelId,
        isVip: this.Info.isMember,
        productId: productId || this.currentProduct.productId
      };
    },
    renewDoc() {
      //打开续费说明
    },
    showEquities(index) {
      let urlO = window.location.href.replace(
        /member_new/,
        "member_equity_new"
      );
      console.log(urlO + "&active=" + index + "&entry=0");
      let url = encodeURIComponent(urlO + "&active=" + index + "&entry=0");

      window.location.href =
        "hybird://method/openNewWindow?url=" + url;
      //  this.$router.push("/member/member_equity_new?active=" + index + "&title=VIP会员尊享内容特权");
    },
    goQuestion() {
      let url = window.location.href.split("?")[0];
      let path =
        this.source === "ios"
          ? url.split("member_new").join("common_problems")
          : url.split("member_new").join("common_problems?hideTitleBar=false");
      console.log(path);
      url = encodeURIComponent(path);
      window.location.href = "hybird://method/openNewWindow?url=" + url;
    },
    goPrivacy() {
      let url = encodeURIComponent(this.source === "ios"
        ? "https://ssweb.knowbox.cn/web4activity/feed_agreement/aiclass-privacy-iOS.html?hideTitleBar=false"
        : "https://ssweb.knowbox.cn/web4activity/feed_agreement/aiclass-privacy.html?hideTitleBar=false"
      );
      
      window.location.href =
        "hybird://method/openNewWindow?url=" +
        url +
        "&title=小盒课堂用户隐私协议";
    },
    toggleMemberProductPopup() {
      this.showSameProductPopup = !this.showSameProductPopup;
    },
    restoreProduct(){
      restoreProduct();
    },
    jump(item) {
      if (item.jumpUrl) {
        utils.sendLog({
          token: token,
          version: version,
          source: source,
          extensionJson: {
            actBannerId: item.id,
          }
        }, 'hzxx3246');
        let url = encodeURIComponent(item.jumpUrl);
        window.location.href = "hybird://method/openNewWindow?url=" + url;
      }
    },
    // 跳转到小盒商城
    handleJumpToShop() {
      utils.sendLog({
        token,
        version,
        source,
        extensionJson: {
          product: this.selectMenu
        }
      }, 'hzxx4212');

      setTimeout(() => {
        // let from = 'app,iosparents,10';
        let from = 'app,iosparents,17';

        if (this.sourceC === 'and') {
          // from = 'app,androidparents,10';
          from = 'app,androidparents,17';
        }

        window.location.href = `hybird://method/openCustomParamsWXMiniProgram?userName=gh_6a5ef4d7fbbe&miniProgramType=0&isShowConfirmDialog=0&path=${encodeURIComponent('/pages/entry/index?from=' + from)}`;
      }, 200);
    },

    handleCloseAct20230901Dialog() {
      this.showAct20230901Dialog = false;
    }
  },
  computed: {
    //支付成功后弹窗中图片的url
    popupImgUrl() {
      switch (this.selectMenu) {
        case 0:
          return "https://susuanqiniu.knowbox.cn/fe/xhxx/member-new/voucher-30.png";
        case 1:
          return "https://susuanqiniu.knowbox.cn/fe/xhxx/member-new/voucher-68.png";  
        case 2: 
          return "https://susuanqiniu.knowbox.cn/fe/xhxx/member-new/voucher-248.png";
        default:
          return "";
      }
    },
    //支付成功后弹窗中图片的文字
    popupText() {
      switch (this.selectMenu) {
        case 0:
          return "30元代金券";
        case 1:
          return "68元代金券";
        case 2:
          return "248元代金券+爱立熊便携家用打印机";
      }
    }
  },
};
</script>
<style lang="scss" scoped>
// px : rem = 50 : 1
.mermber {
  overflow: hidden;
  text-align: center;
  font-family: PingFangSC-Medium;
  line-height: 1;
  min-height: 13.34rem;
  .head-bg {
    height: 3.6rem;
    background: #ffffff linear-gradient(360deg, #fff4e8 0%, #ffe3c6 100%);
    &.decennial-bg {
      background: linear-gradient( 180deg, #FFBFC5 0%, #FFF7F8 100%) !important;
    }
  }
  .main {
    position: absolute;
    top: 1.02rem;
    width: 100%;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    .title_img {
      border-top-left-radius: 0.30rem;
      border-top-right-radius: 0.30rem;
      width: 6.7rem;
      height: 1.2rem;
    }
    .activity_img{
       width: 6.7rem;
      height: 8.08rem;
      margin-bottom: 0.48rem;
    }

    .activity-banner {
      // margin-bottom: 0.64rem;
      margin: 0 -0.4rem 0.64rem;
      .pic {
        width: 6.7rem;
        height: 17.12rem;
      }
      .return-money-pic {
        // width: 6.7rem;
        width: 100vw;
      }
    }

    .content {
      padding: 0.48rem 0.4rem 0.56rem 0.4rem;
      background: #ffffff;
      margin-top: -0.04rem;
      box-shadow: 0 -0.2rem 0.24rem 0 rgba(184, 74, 0, 0.1);
      border-radius: 0.3rem 0.3rem 0 0;
      text-align: left;
      .actBanner-swiper{
        height: 1.2rem;
        // background: linear-gradient(180deg, #ffffff 0%, #f7f8fa 100%);
        // margin-bottom: 0.64rem;
        margin-bottom: 0.5rem;
        .banner-list {
          width: 100%;
          font-size: 0;
          height: 1.2rem;
          /* border-radius: 0.64rem; */
          .actBanner {
            width: 100%;
            height: 100%;
          }
        }
      }
      .vip-text {
        width: 0.72rem;
        height: 0.48rem;
        font-size: 0.36rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1b2a42;
        line-height: 0.48rem;
        &:after {
          content: "";
          position: absolute;
          width: 0.88rem;
          height: 0.48rem;
          background: url("../../assets/images/member_new/vip_img.png") 0 0 /
            cover no-repeat;
        }
      }
      .rights{
        display: flex;
        align-items: center;
        margin-top: 0.64rem;
        .vip-rights{
          flex: 1;
          .title-block{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 1.16rem;
            background: linear-gradient(180deg, #FFDAB0 0%, #FFBD7E 100%);
            border-radius: 0.3rem 0.3rem 0px 0px;
            .icon{
              width: 0.56rem;
              height: 0.56rem;
              margin-right: 0.04rem;
            }
            .text{
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #7A3104;
              line-height: 0.56rem;
              padding: 0.02rem 0.16rem 0 0;
            }
          }
          .rights-block{
            background: #FFF3E9;
            border-radius: 0px 0px 0.3rem 0.3rem;
            border: 0.01rem solid #FFA509;
            width: 100%;
            padding: 0 0.3rem;
            box-sizing: border-box;
            // display: flex;
            // flex-direction: column;
            // align-items: center;
            height: 8rem;
            box-sizing: border-box;
            .rights-cell{
              padding-top: 0.42rem;
              display: flex;
              align-items: flex-start;
              flex-direction: column;
              .benefit-type{
                display: flex;
                align-items: center;
                justify-content: center;
                .vip-icon{
                  width: 0.48rem;
                  height: 0.3rem;
                }
                .title{
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #7A3104;
                  padding-left: 0.12rem;
                }
              }
              .list{
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0.26rem 0.07rem 0;
                width: 100%;
                box-sizing: border-box;

                .list-cell{
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  width: 1rem;
                  .list-icon{
                    width: 0.56rem;
                    height: 0.56rem;
                  }
                  .list-text{
                    font-size: 9px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #3A4961;
                    padding-top: 0.08rem;
                  }
                }
              }
            }
          }
        }
        .not-vip-rights{
          width: 2.36rem;
         
          .title-block{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 0.98rem;
            background: linear-gradient(180deg, #F1F5F9 0%, #EBF1F5 100%);
            border-radius: 0px 0.3rem 0px 0px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #3A4961;
          }
          .cnt{
            height: 7.82rem;
            width: 100%;
            box-sizing: border-box;
            background: #F9FBFC;
            border-radius: 0px 0px 0.3rem 0px;
            border: 0.01rem solid #D7E5F7;
            border-left: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0.26rem 0.24rem 0;
            .cnt-cell{
              width: 1.94rem;
              padding: 0.6rem 0;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 11px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #3A4961;
              line-height: 0.34rem;
              flex-direction: column;
            }
            .cnt-cell +  .cnt-cell{
              border-top: solid 0.01rem #CCDBE8;
            }
          }
        }
      }
      .vip-img {
        width: 0.88rem;
        height: 0.48rem;
      }
      .menu {
        padding-top: 0.36rem;
        padding-bottom: 0.48rem;
        // padding-left: 0.1rem;
        // display: flex;
        display: -webkit-box;
        // overflow: scroll;
        overflow-x: auto;
        .text-doc {
          margin-top: 0.42rem;
          margin-bottom: 0.2rem;
          font-size: 0.3rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #202b43;
          line-height: 0.42rem;
        }
        .price {
          font-size: 0.6rem;
          font-family: BebasNeue;
          color: #ff8b1f;
          margin-left: -0.08rem;
          line-height: 0.64rem;
          font-weight: bold;
        }
        .price-icon {
          width: 0.22rem;
          height: 0.56rem;
          font-size: 0.36rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          margin-left: -0.12rem;
          color: #ff8b1f;
          line-height: 0.56rem;
          margin-top: 0.05rem;
        }
        .price-discount{
          color:#FCB170;
          font-size: 0.24rem;
        }
        .second {
          font-size: 0.24rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          // color: #fcb170;
          color: #A2B1BF;
          line-height: 0.34rem;
          text-decoration: line-through;
        }
        .item-nom {
          font-size: 0.22rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          // color: #a2b1bf;
          color: #FF6E45;
          line-height: 0.22rem;
          position: absolute;
          width: 2.1rem;
          bottom: 0.18rem;
          &.decennial-sign-bg {
            position: absolute;
            bottom: 0.14rem;
            left: 0.2rem;
            right: 0.2rem;
            width: 1.7rem;
            height: 0.36rem;
            color: #ffffff;
            background: url('https://susuanqiniu.knowbox.cn/fe/xhxx/member-new/xiaohe-vip-decennial-sign-icon.png') center / cover no-repeat;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.22rem;
          }
        }
        .item-no {
          position: relative;
          // width: 1.92rem;
          width: 2.1rem;
          height: 2.6rem;
          background: #ffffff;
          // box-shadow: 0px 4px 20px 0px rgba(207, 207, 207, 0.3);
          box-shadow: 0 0.08rem 0.16rem 0 rgba(220,222,224,0.3);
          border: 0.02rem solid #EBEDF0;
          border-radius: 0.3rem;
          text-align: center;
          margin-right: 0.2rem;
          &:last-child {
            margin-right: 0 !important;
          }
          .tip-bg {
            font-size: 0.22rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #a2b1bf;
            line-height: 0.22rem;
            position: absolute;
            // width: 1.92rem;
            width: 2.1rem;
            bottom: 0.16rem;
          }
        }
        .item {
          position: relative;
          // width: 1.92rem;
          width: 2.1rem;
          height: 2.6rem;
          background: #fff8f2;
          // box-shadow: 0rem 0.16rem 0.16rem 0rem rgba(255, 146, 45, 0.3);
          border-radius: 0.3rem;
          // border: 0.02rem solid #fcb170;
          box-shadow: 0 0.08rem 0.16rem 0 rgba(255,146,45,0.3);
          border: 0.02rem solid #FF6E45;
          text-align: center;
          margin-right: 0.2rem;
          .tip-bg {
            position: absolute;
            bottom: -0.02rem;
            // width: 1.92rem;
            width: 2.1rem;
            height: 0.56rem;
            // background: #ff8b1f;
            background: #FF6E45;
            // border-radius: 0 0 0.3rem 0.28rem;
            border-radius: 0 0 0.3rem 0.3rem;
            font-size: 0.24rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 0.34rem;
            padding-top: 0.1rem;
            margin-left: -0.02rem;
            &.decennial-sign-bg {
              position: absolute;
              bottom: 0.14rem;
              left: 0.2rem;
              right: 0.2rem;
              width: 1.7rem;
              height: 0.36rem;
              background: url('https://susuanqiniu.knowbox.cn/fe/xhxx/member-new/xiaohe-vip-decennial-sign-icon.png') center / cover no-repeat;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.22rem;
              padding-top: 0;
              border-radius: 0;
            }
          }
        }
      }
      .tip-above-bg {
            position: absolute;
            padding: 0.08rem;
            // width: 1.2rem;
            // height: 0.36rem;
            // background: linear-gradient(90deg, #FF6F40 0%, #FF3535 100%);
            background: linear-gradient( 90deg, #FF3535 0%, #FF774B 100%);
            border-radius: 0.6rem 0.6rem 0.6rem 0rem;
            font-size: 0.22rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            // line-height: 0.34rem;
            // padding-top: 0.03rem;
            top: -0.15rem;
            margin-left: -0.02rem;
          }
      .tip-doc {
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #a2b1bf;
        line-height: 0.34rem;
        position: relative;
        margin-bottom: 0.32rem;
        &:after {
          content: "";
          position: absolute;
          top: 0.03rem;
          margin-left: 0.06rem;
          width: 0.24rem;
          height: 0.24rem;
          background: url("../../assets/images/member_new/remind_icon.png") 0 0 /
            cover no-repeat;
        }
      }
      .tipNoAfter {
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #a2b1bf;
        line-height: 0.34rem;
        position: relative;
        margin-bottom: 0.48rem;
      }
      .benifit-list{
        margin-top: 0.26rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // display: -webkit-box;
        width: 100%;
        flex-wrap: wrap;
        // text-align: center;
        .benifit-list-child{
          width: 1.54rem;
          // margin-right:  0.2rem;
          text-align: center;
          margin-bottom: 0.1rem;
          .img{
            width: 0.84rem;
            height: 0.84rem;
            margin-bottom: 0.12rem;
          }
          .text{
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #3A4961;
            line-height: 17px; 
            }
        }
      }
      .img-list {
        margin-top: 0.36rem;
        & > img {
          width: 6.7rem;
          height: 2.2rem;
          margin-bottom: 0.24rem;
        }
        .img-item {
          width: 6.7rem;
          height: 2.2rem;
          margin-bottom: 0.24rem;
        }
      }
      .renew-doc {
        font-size: 0.3rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3a4961;
        line-height: 0.42rem;
        margin-top: 0.7rem;
      }
      .rener-doc-p {
        & > p {
          font-size: 0.24rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #8597a6;
          line-height: 0.34rem;
          margin-top: 0.16rem;
        }
      }
    }
    .other {
      margin-top: 0.24rem;
      background-color: #ffffff;
      .o-item {
        padding: 0rem 0.4rem 0rem 0.4rem;
      }
      .o-text {
        width: 100%;
        height: 1.2rem;
        font-size: 0.3rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3a4961;
        line-height: 1.2rem;
        text-align: left;
        position: relative;
        &:after {
          content: "";
          position: absolute;
          width: 0.44rem;
          height: 0.44rem;
          top: 0.4rem;
          right: 0;
          background: url("../../assets/images/member_new/right_arrow.png") 0 0 /
            cover no-repeat;
        }
      }
      .line {
        height: 0.01rem;
        background: #e6eaed;
      }
      .o-bottom {
        padding: 0.36rem 0.4rem 0.48rem 0.4rem;
        text-align: left;
        margin-bottom: 0.54rem;
        .text-bottom {
          font-size: 0.3rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #3a4961;
          line-height: 0.42rem;
        }
        .b-tip {
          margin-top: 0.16rem;
          font-size: 0.24rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #8597a6;
          line-height: 0.34rem;
          & > span {
            color: #43a5f3;
          }
        }
      }
    }
    .footer-zhan {
      height: 1.74rem;
    }
  }

  .pop-content {
    padding: 0.48rem 0.48rem 1.76rem 0.48rem;
    .pop-title {
      font-size: 0.4rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3a4961;
      line-height: 0.56rem;
      margin-bottom: 0.18rem;
    }
    .pop-scroll {
      height: 4.32rem;
      overflow: auto;
      & > p {
        width: 4.64rem;
        font-size: 0.3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3a4961;
        line-height: 0.44rem;
        text-align: left;
        margin-bottom: 0.18rem;
      }
    }

    .pop-footer {
      position: absolute;
      bottom: 0;
      height: 1.76rem;
      background-color: #ffffff;
      .know {
        margin-top: 0.48rem;
        width: 4.64rem;
        height: 0.88rem;
        background: linear-gradient(90deg, #ffdab1 0%, #fcb170 100%);
        border-radius: 0.44rem;
        font-size: 0.32rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #7a3104;
        line-height: 0.44rem;
        padding: 0.2rem 0.184rem 0.24rem 0.184rem;
      }
    }
  }
  .pop-suc {
    width: 5.72rem;
    height: 7.4rem;
    border-radius: 0.3rem;
    .pop-img {
      width: 5.72rem;
      height: 5.88rem;
      position: absolute;
      right: 0;
    }
    .pop-suc-title {
      margin-top: 0.48rem;
      font-size: 0.4rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1b2a42;
      line-height: 0.56rem;
    }
    .pop-text {
      margin-top: 0.24rem;
      font-size: 0.3rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3a4961;
      line-height: 0.44rem;
    }
    .pop-begin {
      width: 4.64rem;
      height: 0.88rem;
      background: #ff6e45 linear-gradient(90deg, #ffdab1 0%, #fcb170 100%);
      border-radius: 0.44rem;
      font-size: 0.32rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #7a3104;
      line-height: 0.88rem;
      position: absolute;
      bottom: 0.1rem;
      right: 0.48rem;
    }
  }
  .share-wrap{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,0.7);
        z-index: 10;
  }
}
/deep/ .suc-van-popup-container .van-popup {
  overflow-y: visible;
}
.suc-van-popup-container .van-popup {
    position: fixed;
    max-height: 100%;
    overflow-y: auto;
    background: none;
    -webkit-transition: -webkit-transform .3s;
    transition: -webkit-transform .3s;
    transition: transform .3s;
    transition: transform .3s, -webkit-transform .3s;
    transition: transform .3s,-webkit-transform .3s;
    -webkit-overflow-scrolling: touch;
}

.act20230901-dialog {
  width: 6rem;
  height: 6.32rem;
  background: #fff;
  border-radius: 0.32rem;

  .title {
    font-size: 0.4rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1B2A42;
    line-height: 0.56rem;
    margin: 0.48rem 0 0.24rem;
  }

  .bd {
    margin-bottom: 0.72rem;

    .coin {
      width: 2.64rem;
      height: 2.64rem;
    }

    .text {
      font-size: 0.28rem;
      font-family: PingFang SC;
      color: #1B2A42;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      /* line-height: 0.56rem; */
    }
  }

  .ft {
    .button {
      width: 5.04rem;
      height: 0.88rem;
      line-height: 0.88rem;
      text-align: center;
      background: linear-gradient(90deg, #FFDAB1 0%, #FCB170 100%);
      border-radius: 0.44rem;
      font-size: 0.32rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #7A3104;
      margin: 0 auto;
    }
  }

  .close {
    width: 0.44rem;
    height: 0.44rem;
    background: url(https://susuanqiniu.knowbox.cn/fe/xhxx/member-new/close.png);
    background-size: cover;
    position: absolute;
    right: 0.16rem;
    top: 0.16rem;
  }
}
</style>
